import { message } from "antd";

document.addEventListener("click", (e) => {
  let target = e.target as HTMLElement;
  if (!target.classList.contains("__copy__")) {
    target = target.closest(".__copy__") as any;
  }

  if (!target) {
    return;
  }

  let html = target.getAttribute("data-html");

  if (target.closest(".ql-editor") && html === "true") {
    message.warn("Copy button may not work properly in this editor");
  }

  if (!html) {
    message.error("Nothing to copy");
    return;
  }

  const div = document.createElement("div");
  div.className = "__hidden__";
  div.innerHTML = html;
  document.body.appendChild(div);

  // select the div
  const selection = window.getSelection();
  const range = document.createRange();
  range.selectNodeContents(div);
  selection!.removeAllRanges();
  selection!.addRange(range);
  // copy
  document.execCommand("copy");
  // clear selection
  selection!.removeAllRanges();
  message.success("Copied to clipboard");
  e.preventDefault();
  document.body.removeChild(div);
});

export default {};
